// extracted by mini-css-extract-plugin
module.exports = {"occupanciesContainer":"rate_plan_occupancy_occupanciesContainer__3zi_Z","occupancyCell":"rate_plan_occupancy_occupancyCell__3Q6vX"};